import React from 'react';
import { useRouteMatch, useLocation } from 'react-router-dom';
import { TabBar, TabButton } from '~/components';
import { apps } from '~/utils/mocks/apps';
import { theme } from '~/styles/theme';
import { useSelector } from 'react-redux';
import * as S from './styles';

export default function SubRouteSwitch({ ...rest }) {
  const { url } = useRouteMatch();
  const location = useLocation();
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const isCurrentPath = pathString => {
    return location.pathname.includes(pathString);
  };

  const getPathname = route => `${url}/previous/${route}`;

  const navigateTo = route => {
    return isCurrentPath(route) ? `${url}/previous` : getPathname(route);
  };

  const styleTab = {
    primaryColor: match?.competitionId === 1 ? theme.coral : theme.turquoise,
    secondaryColor: theme.white,
    contrastColor: theme.dark,
    textColor: theme.white,
  };

  return (
    <TabBar
      {...rest}
      value={location.pathname !== `${url}/previous` ? location.pathname : null}
      styleTab={styleTab}
    >
      {apps.map(app => {
        return (
          <TabButton
            key={app.route}
            value={getPathname(app.route)}
            label={
              <S.CustomNavLink to={navigateTo(app.route)}>
                <S.TabIcon size={30} name={app.icon} />
              </S.CustomNavLink>
            }
          />
        );
      })}
    </TabBar>
  );
}
